'use strict';

import angular from 'angular';
import { CategoriasRouteComponent } from './categorias-route.component.js';
import { EditarCategoriaRouteComponent } from './editar/editar-categoria.component';
import CategoriasService from './categorias-route.service';
const ngRoute = require('angular-route');

/*@ngInject*/
const routeCategoria = function ($routeProvider) {
    $routeProvider
        .when('/categorias', {
            template: '<categorias-route categorias="$resolve.categorias.data.categorias"></categorias-route>',
            resolve: {
                categorias: getCategorias
            },
            authenticate: true,
            administrator: true
        })
        .when('/categorias/editar/:categoria', {
            template: '<editar-categoria-route categoria="$resolve.categoria"></editar-categoria-route>',
            resolve: {
                categoria: getPathCategoria
            },
            authenticate: true,
            administrator: true
        })
        .when('/categorias/editar/:categoria/:subcategoria', {
            template: '<editar-categoria-route categoria="$resolve.categoria" subcategoria="$resolve.subcategoria"></editar-categoria-route>',
            resolve: {
                categoria: getPathCategoria,
                subcategoria: getPathSubcategoria
            },
            authenticate: true,
            administrator: true
        });


    function getCategorias(CategoriasService) {
        return CategoriasService.getCategorias();
    }

    function getPathCategoria($route) {
        return $route.current.params.categoria;
    }

    function getPathSubcategoria($route) {
        return $route.current.params.subcategoria;
    }

    // function getSubcategoria(CategoriasService){
    //     return CategoriasService.getCategorias();
    // }
};

export default angular.module('pizzutoAutopartesApp.categorias', [ngRoute])
    .component(CategoriasRouteComponent.selector, CategoriasRouteComponent)
    .component(EditarCategoriaRouteComponent.selector, EditarCategoriaRouteComponent)
    .service('CategoriasService', CategoriasService)
    .config(routeCategoria)
    .name;


// WEBPACK FOOTER //
// ./client/app/categorias-route/index.js